module.exports = __webpack_public_path__ + "img/circle1.56b418c4.gif";